import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MerakiAiComponent } from './meraki-ai.component';
import { MerakiAiRoutingModule } from './meraki-ai-routing.module';
import { FormsModule } from '@angular/forms';
import { MatTableModule } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MarkdownModule } from 'ngx-markdown';



@NgModule({
  declarations: [
    MerakiAiComponent
  ],
  imports: [
    CommonModule,
    MerakiAiRoutingModule,
    FormsModule,
    MatTableModule,
    MatTooltipModule,
   MarkdownModule.forChild()
  ]
})
export class MerakiAiModule { }
